import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Heading,
  Link,
  Text,
  ListItem,
  OrderedList,
  Box,
} from "@chakra-ui/react";

const RulesText = () => {
  return (
    <>
      <Heading mb={4} pt={8} color="gray.700" fontSize="lg" textAlign="center">
        REGULAMENTO "Concurso de Pratos Spoleto 2022"
      </Heading>
      <OrderedList>
        <ListItem>
          <Text>
            Empresa Mandatária: <br />
            Razão Social: SPOLETO FRANCHISING LTDA <br />
            Endereço: DOS METALURGICOS Número: 9640 Bairro: CASA DE PEDRA
            Município: VOLTA REDONDA UF: RJ CEP:27258-000 <br />
            CNPJ/MF nº: 03.724.731/0001-78
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>
            MODALIDADE DA PROMOÇÃO: <br />
            Concurso
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>
            ÁREA DE ABRANGÊNCIA:
            <br />
            Todo o território nacional.
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>
            PERÍODO DA PROMOÇÃO: <br />
            09/05/2022 a 08/07/2022
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>
            PERÍODO DE PARTICIPAÇÃO:
            <br />
            09/05/2022 a 04/07/2022
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>
            CRITÉRIO DE PARTICIPAÇÃO:
            <br />
            Podem participar do presente concurso qualquer pessoa física, de
            nacionalidade Brasileira, residente e domiciliada em território
            nacional, com idade igual ou maior de 16 (dezesseis) anos de idade
            no ato de inscrição e que preencha os demais requisitos exigidos no
            presente regulamento.
            <br />
            <br />
            É proibida a participação de diretores, administradores e
            funcionários da empresa promotora, assim como de qualquer empresa
            integrante de seu grupo econômico e que seja franqueada da marca
            SPOLETO®, bem como de seus parentes de segundo grau e/ou cônjuges.
            Caso seja apurado, a qualquer momento, que o participante se
            enquadra na descrição acima, o mesmo será sumariamente
            desqualificado.
            <br />
            <br />
            A empresa promotora divulgará o presente concurso nas redes sociais
            da marca SPOLETO®
            [http://concursopratos2022.spoleto.com.br|facebook/spoleto,instagram
            @spoleto_oficial ], nos restaurantes SPOLETO® e em mídia impressa em
            todo o território nacional.
            <br />
            <br />
            Para participar do concurso não será necessária a compra de qualquer
            bem, direito ou serviço da empresa promotora ou de terceiros.
            <br />
            <br />
            Cronograma:
            <br />
            a. Início e término da promoção: 09/05/2022 a 08/07/2022.
            <br />
            b. Período de inscrição e envio das artes: 09/05/2022 a 06/06/2022.
            <br />
            c. Etapa de Pré-Seleção pelo Júri Especial: 08/06/2022 a 13/06/2022.
            <br />
            d. Etapa de Votação Pública: 17/06/2022 a 04/07/2022.
            <br />
            e.Divulgação do Resultado:08/07/2022 no site{" "}
            <Link
              color="blue"
              href="https://concursopratos2022.spoleto.com.br/"
              textDecoration="underline"
              target="_blank"
            >
              {" "}
              https://concursopratos2022.spoleto.com.br/{" "}
            </Link>
          </Text>

          <Text mt={4}>
            A inscrição para participação do presente concurso será feita
            inteiramente por meio do site oficial do concurso:
            <Link
              color="blue"
              href="https://concursopratos2022.spoleto.com.br/"
              textDecoration="underline"
              target="_blank"
            >
              {" "}
              https://concursopratos2022.spoleto.com.br/{" "}
            </Link>{" "}
            e será oferecido aos participantes, para download no ato de
            inscrição, arquivo eletrônico com o template e a paleta de cores que
            poderão ser utilizadas para o desenvolvimento da arte.
          </Text>

          <Text mt={4}>
            Todas as artes inscritas precisam utilizar, obrigatoriamente, o
            template e até 02 (duas) cores da paleta disponibilizada no ato da
            inscrição e devem ter como inspiração o tema “ESTAMPAS DA NATUREZA”
          </Text>

          <Text mt={4}>
            As artes devem ser desenvolvidas exclusivamente pelo participante
            que realizar o seu cadastro no site do concurso, sendo proibida a
            inscrição de artes desenvolvidas em co- autoria. Dessa forma, o
            participante declara que é o titular integral do direito autoral da
            arte enviada e que cederá os seus direitos no caso de sua arte ser
            vencedora deste concurso.
          </Text>

          <Text mt={4}>
            Não há limitação em relação a quantidade de envio de artes por
            artista.
          </Text>

          <Text mt={4}>
            A identificação do participante se dará por meio numeração gerada
            pelo sistema do site do concurso, sendo proibida a aplicação de
            nomes/identificação nas artes. Acaso a arte venha com qualquer
            identificação o participante será desclassificado.
          </Text>

          <Text mt={4}>
            As artes apresentadas devem, obrigatoriamente, estar baseadas nos
            critérios do tema definido “ESTAMPAS DA NATUREZA” e deverão ser
            encaminhadas pelo site do concurso
            http://concursopratos2022.spoleto.com.br, no qual será possível
            preencher a ficha de inscrição, download do template/paleta de
            cores, assim como fazer upload dos arquivos, considerando as
            seguintes especificações técnicas: (a) não é permitido o uso de
            quadricomia; (b) o degradê é permitido apenas por meio de retícula;
            (c) o uso de retículas é autorizado em áreas pequenas e os
            percentuais autorizados estão descritos na paleta de cores que se
            encontra no template; (d) a espessura mínima para linhas deve ser de
            0.5pts; (e) as artes devem ser enviadas em formato JPG, com no
            máximo 1Mb e no mínimo 1080x1080px, já com as cores da paleta
            aplicadas; (f) os participantes deverão manter os arquivos .EPS e
            .AI de suas artes, pois os vencedores deverão enviar as artes em um
            destes formatos para recebimento dos prêmios.
          </Text>

          <Text mt={4}>
            Os participantes devem estar cientes que as artes serão impressas em
            cerâmica, na Campanha de Pratos do Spoleto 2022, em processo de
            tampografia em 2 cores, podendo ocorrer variação nas cores e
            desenhos, além de adaptações, que poderão ser feitas livremente pelo
            SPOLETO® para aos riscos de faca dos modelos de cerâmica.
          </Text>

          <Text mt={4}>
            Após iniciado o período de inscrição da promoção, a Secretaria
            Executiva do concurso, diariamente, fará a análise de todas as artes
            apresentadas pelos participantes e desclassificará aquelas que não
            cumprirem os requisitos formais anteriormente citados assim como
            descumpram quaisquer disposições do presente regulamento.
          </Text>

          <Text mt={4}>
            Após o encerramento do período de inscrições, a Secretaria Executiva
            do concurso enviará para o Júri, formado por personalidades
            definidas pelo SPOLETO®, todas as artes regularmente inscritas, para
            que as mesmas sejam avaliadas de acordo com os seguintes quesitos:
            adequação ao tema, compreensão dos desafios e necessidades
            propostas, equilíbrio de cores e formas.
          </Text>

          <Text mt={4}>
            O Júri, no período de 08/06/2022 até 13/06/2022, irá selecionar, em
            ambiente online especialmente designado para este fim, as 30
            (trinta) artes finalistas, que serão as que mais se destacaram no
            desenvolvimento dos quesitos propostos por este concurso.
          </Text>

          <Text mt={4}>
            Após definição das 30 (trinta) artes finalistas pelo Júri, será
            iniciado o período de votação online pelo site do concurso{" "}
            <Link
              color="blue"
              href="https://concursopratos2022.spoleto.com.br/"
              textDecoration="underline"
              target="_blank"
            >
              {" "}
              https://concursopratos2022.spoleto.com.br/{" "}
            </Link>
            , onde as artes serão exibidas, cuja votação ocorrerá das 12:00
            horas de 17/06/2022 até às 12:00 horas de 04/07/2022.
          </Text>

          <Text mt={4}>
            Durante o período de votação online, só será válido apenas 1 voto
            por IP por dia.
          </Text>

          <Text mt={4}>
            Qualquer pessoa poderá votar nas artes finalistas desde que forneça
            os dados solicitados no ato da votação.
          </Text>

          <Text mt={4}>
            Serão consideradas vencedoras as 08 (oito) artes com maior número de
            votos após o encerramento da votação
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>APURAÇÃO E DESCRIÇÃO DE PRÊMIOS:</Text>
          <Text mt={4}>
            PERÍODO DA APURAÇÃO: 08/07/2022 12:00 a 08/07/2022 14:00
            <br />
            PERÍODO DE PARTICIPAÇÃO DA APURAÇÃO: 09/05/2022 12:00 a 04/07/2022
            12:00 23:59
            <br />
            ENDEREÇO DA APURAÇÃO: Rua da Quitanda NÚMERO: 86 COMPLEMENTO: Sala
            301 BAIRRO: Centro
            <br />
            MUNICÍPIO: Rio de Janeiro UF: RJ CEP: 20091-902
            <br />
            LOCAL DA APURAÇÃO: SEDE DA EMPRESA
          </Text>
          <Text mt={4}>PRÊMIOS</Text>
          <br />

          <Box d={["block", null, null, "none"]}>
            <Text as="span" color="gray.600">
              Quantidade:
            </Text>{" "}
            <Text fontSize={13} as="span">
              8
            </Text>
            <br />
            <Text as="span" color="gray.600">
              Descrição:
            </Text>{" "}
            <Text fontSize={13} as="span">
              <br />
              Cartão pré-pago com bloqueio da função saque
            </Text>
            <br />
            <Text as="span" color="gray.600">
              Valor R$:
            </Text>{" "}
            <Text fontSize={13} as="span">
              R$ 5.000,00
            </Text>
            <br />
            <Text as="span" color="gray.600">
              Valor Total R$:
            </Text>{" "}
            <Text fontSize={13} as="span">
              R$ 40.000,00
            </Text>
            <br />
            <Text as="span" color="gray.600">
              Ordem:
            </Text>{" "}
            <Text fontSize={13} as="span">
              1
            </Text>
          </Box>
          <Table
            d={["none", null, null, "table"]}
            className="table-rules"
            variant="simple"
            size="sm"
            maxW={["100%", null, "100%"]}
          >
            <Thead>
              <Tr>
                <Th>Quantidade</Th>
                <Th>Descrição</Th>
                <Th>Valor R$</Th>
                <Th>Valor Total R$</Th>
                <Th>Ordem</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>8</Td>
                <Td>Cartão pré-pago com bloqueio da função saque</Td>
                <Td>R$ 5.000,00</Td>
                <Td>R$ 40.000,00</Td>
                <Td>1</Td>
              </Tr>
            </Tbody>
          </Table>
        </ListItem>
        <br />
        <ListItem>
          <Text>PREMIAÇÃO TOTAL:</Text> <br />
          <Table
            className="table-rules"
            variant="simple"
            size="sm"
            maxW={["100%", null, "100%"]}
          >
            <Thead>
              <Tr>
                <Th textAlign="center">Quantidade Total de Prêmios</Th>
                <Th textAlign="center">Valor total da Promoção R$</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td textAlign="center">8</Td>
                <Td textAlign="center">R$ 40.000,00</Td>
              </Tr>
            </Tbody>
          </Table>
        </ListItem>
        <br />
        <ListItem>
          <Text>FORMA DE APURAÇÃO:</Text>
          <Text mt={4}>
            Após iniciado o período de inscrição da promoção, a Secretaria
            Executiva do concurso, diariamente, fará a análise de todas as artes
            apresentadas pelos participantes e desclassificará aquelas que não
            cumprirem os requisitos formais anteriormente citados assim como
            descumpram quaisquer disposições do presente regulamento.
          </Text>
          <Text mt={4}>
            Após o encerramento do período de inscrições, a Secretaria Executiva
            do concurso enviará para o Júri, formado por personalidades
            definidas pelo SPOLETO®, todas as artes regularmente inscritas, para
            que as mesmas sejam avaliadas de acordo com os seguintes quesitos:
            adequação ao tema, compreensão dos desafios e necessidades
            propostas, equilíbrio de cores e formas.
          </Text>
          <Text mt={4}>
            O Júri, no período de 08/06/2022 até 13/06/2022, irá selecionar, em
            ambiente online especialmente designado para este fim, as 30
            (trinta) artes finalistas, que serão as que mais se destacaram no
            desenvolvimento dos quesitos propostos por este concurso.
          </Text>
          <Text mt={4}>
            Após definição das 30 (trinta) artes finalistas pelo Júri, será
            iniciado o período de votação online pelo site do concurso
            <Link
              color="blue"
              href="https://concursopratos2022.spoleto.com.br/"
              textDecoration="underline"
              target="_blank"
            >
              {" "}
              https://concursopratos2022.spoleto.com.br/{" "}
            </Link>
            , onde as artes serão exibidas, cuja votação ocorrerá das 12:00
            horas de 17/06/2022 até às 12:00 horas de 04/07/2022.
          </Text>
          <Text mt={4}>
            Durante o período de votação online, só será válido apenas 1 voto
            por IP por dia.
          </Text>
          <Text mt={4}>
            Qualquer pessoa poderá votar nas artes finalistas desde que forneça
            os dados solicitados no ato da votação.
          </Text>
          <Text mt={4}>
            Serão consideradas vencedoras as 08 (oito) artes com maior número de
            votos após o encerramento da votação.
          </Text>
          <Text mt={4}>
            No dia 08/07/2022, a partir das 12:00 horas, será divulgado o
            resultado final do concurso no site do concurso
            <Link
              color="blue"
              href="https://concursopratos2022.spoleto.com.br/"
              textDecoration="underline"
              target="_blank"
            >
              {" "}
              https://concursopratos2022.spoleto.com.br/{" "}
            </Link>
            , onde serão exibidas as 8 artes vencedoras.
          </Text>
          <Text mt={4}>
            Caso haja empate no número de votos, será considerado vencedora a
            arte inscrita primeiro no concurso.
          </Text>
          <Text mt={4}>
            As decisões tomadas pelo Júri são soberanas, irrevogáveis,
            irretratáveis e não passíveis de recurso.
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>CRITÉRIOS DE DESCLASSIFICAÇÃO:</Text>
          <Text mt={4}>
            Após iniciado o período de inscrição da promoção, a Secretaria
            Executiva do concurso, diariamente, fará a análise de todas as artes
            apresentadas pelos participantes e desclassificará aquelas que não
            cumprirem os requisitos formais conforme previstos nos critérios de
            participação.
          </Text>
          <Text mt={4}>
            Será automaticamente excluído o participante que se recusar a
            assinar o recibo de entrega dos prêmios na forma estabelecida pela
            empresa, e/ou não apresentar documento que comprove a efetividade de
            sua relação com a instituição de ensino ou de seu coordenador, se
            solicitado.
          </Text>
          <Text mt={4}>
            Será automaticamente excluída a arte do participante, onde seja
            notória a inspiração em obra de arte de outros artistas, ainda que
            na forma de sátira ou paródia.
          </Text>
        </ListItem>
        <br />
        <ListItem>
          <Text>FORMA DE DIVULGAÇÃO DO RESULTADO:</Text>
          <Text mt={4}>
            No dia 08/07/2022, a partir das 12:00 horas, será divulgado o
            resultado final do concurso no site do concurso
            <Link
              color="blue"
              href="https://concursopratos2022.spoleto.com.br/"
              textDecoration="underline"
              target="_blank"
            >
              {" "}
              https://concursopratos2022.spoleto.com.br/{" "}
            </Link>
            , onde serão exibidas as 8 artes vencedoras.
          </Text>
        </ListItem>
        <ListItem>
          <Text>ENTREGA DOS PRÊMIOS:</Text>
          <Text mt={4}>
            Local da entrega da premiação: No domicílio dos contemplados, até 30
            dias a contar da data da apuração de acordo com o Decreto 70951/72 –
            Artigo 5º. Os prêmios distribuídos deverão ser livres e
            desembaraçados de qualquer ônus para os contemplados e serão
            entregues aos contemplados em até 30 dias contados da data de
            contemplação.
          </Text>
          <Text mt={4}>
            A promotora garante que guarda consigo todas as evidências de
            participação na promoção, podendo esta comprovar, em caso de
            necessidade, a veracidade e o cumprimento dos requisitos de
            participação dos contemplados e demais participantes, a qualquer
            tempo durante a promoção, ou ainda, em período posterior ao término
            da promoção, devendo a promotora armazenar essas evidências, pelo
            prazo de 3 anos
          </Text>
        </ListItem>
        <ListItem>
          <Text>DISPOSIÇÕES GERAIS:</Text>
          <Text mt={4}>
            Os participantes devem estar cientes que as artes serão impressas em
            cerâmica, na Campanha de Pratos do 2022, em processo de tampografia
            em 2 cores, podendo ocorrer variação nas cores e desenhos, além de
            adaptações, que poderão ser feitas livremente pelo SPOLETO® para aos
            riscos de faca dos modelos de cerâmica.
          </Text>

          <Text mt={4}>
            Havendo interrupção ou suspensão do concurso ou da publicação dos
            ganhadores no site do concurso devido a problemas de acesso à rede
            de internet, intervenção de hackers, vírus, manutenção, queda de
            energia, falhas de softwares ou hardwares, problemas com servidores
            ou provedores do internauta ou da empresa promotora, por decisão ou
            razão de caso fortuito ou força maior, não será devida qualquer
            indenização ou compensação aos participantes deste concurso e aos
            eventuais terceiros prejudicados. Mediante autorização da SECAP.
          </Text>

          <Text mt={4}>
            Todas as questões serão avaliadas segundo os critérios estabelecidos
            pelo SPOLETO®, e a aceitação do concorrente à participação neste
            concurso implica renúncia expressa a qualquer questionamento sobre
            os critérios adotados, prevalecendo sempre o critério da comissão
            julgadora.
          </Text>

          <Text mt={4}>
            A peça artística não poderá, em hipótese alguma, sob pena de
            desqualificação, possuir conteúdo que remeta a discriminação,
            discurso de ódio ou incitação à violência, que seja inapropriado
            para veiculação para menores de 18 (dezoito) anos, ou que faça uso
            de marca de qualquer produto ou serviço ou, ainda, que viole o
            direito de terceiros. Os CONTEMPLADOS inscritos concordam com o uso
            gratuito e livre de qualquer ônus ou encargo de seu nome, sua imagem
            e voz em fotos, arquivos e/ou meios digitais ou não, ou em qualquer
            tipo de mídia e/ou peças promocionais, inclusive televisão, revista,
            rádio, jornal, cartazes, internet, faixas e outdoors, mídia social,
            no território nacional para ampla divulgação da conquista do prêmio
            e/ou do conteúdo do vencedor no prazo de até 1 (UM) ANO após a data
            de apuração.
          </Text>

          <Text mt={4}>
            Os CONTEMPLADOS inscritos concordam com o uso gratuito e livre de
            qualquer ônus ou encargo de seu nome, sua imagem e voz em fotos,
            arquivos e/ou meios digitais ou não, ou em qualquer tipo de mídia
            e/ou peças promocionais, inclusive televisão, revista, rádio,
            jornal, cartazes, internet, faixas e outdoors, mídia social, no
            território nacional para ampla divulgação da conquista do prêmio
            e/ou do conteúdo do vencedor no prazo de até 1 (UM) ANO após a data
            de apuração.
          </Text>

          <Text mt={4}>
            Será automaticamente excluído o participante que se recusar a
            assinar o recibo de entrega dos prêmios na forma estabelecida pela
            empresa, e/ou não apresentar documento que comprove a efetividade de
            sua relação com a instituição de ensino ou de seu coordenador, se
            solicitado.
          </Text>

          <Text mt={4}>
            Local da exibição da premiação: por questão de segurança a empresa
            não promoverá a exposição da premiação. Será comprovada a
            propriedade do prêmio até 8 (oito) dias antes da data marcada para o
            sorteio ou realização do concurso. As dúvidas e controvérsias
            oriundas de reclamações dos consumidores participantes da promoção
            deverão ser preliminarmente, dirimidas pelos seus respectivos
            organizadores e, posteriormente, submetidas à SECAP O PROCON, bem
            como os órgãos conveniados, em cada jurisdição receberão as
            reclamações devidamente fundamentadas, dos consumidores
            participantes.
          </Text>
        </ListItem>

        <ListItem mt={4}>
          <Text>TERMO DE RESPONSABILIDADE</Text>
          <Text mt={4}>
					Poderá participar da promoção qualquer consumidor que preencha os requisitos estipulados no regulamento da campanha
autorizada;
            <br />
            <br />
            Os prêmios não poderão ser convertidos em dinheiro;
            <br />
            <br />
            É vedada a apuração por meio eletrônico;
            <br />
            <br />
            Os prêmios serão entregues em até 30 dias da data da apuração/sorteio, sem qualquer ônus aos contemplados
            <br />
            <br />
            Quando o prêmio sorteado, ganho em concurso ou conferido mediante vale-brinde, não for reclamado no prazo de cento e
oitenta (180) dias, contados, respectivamente, da data do sorteio, da apuração do resultado do concurso ou do término do prazo
da promoção, caducará o direito do respectivo titular e o valor correspondente será recolhido, pela empresa autorizada, ao
Tesouro Nacional, como renda da União, no prazo de quarenta e cinco (45) dias;
            <br />
            <br />
            A divulgação da imagem dos contemplados poderá ser feita até um ano após a apuração da promoção comercial;
            <br />
            <br />
            As dúvidas e controvérsias oriundas de reclamações dos participantes serão, primeiramente, dirimidas pela promotora,
persistindo-as, estas deverão ser submetidas à Secap/ME;
            <br />
            <br />
            Os órgãos locais de defesa do consumidor receberão as reclamações devidamente fundamentadas;
            <br />
            <br />
            A prestação de contas deverá ser realizada no prazo máximo de trinta dias após a data de prescrição dos prêmios sob pena de
descumprimento do plano de distribuição de prêmios;
            <br />
            <br />
            O regulamento deverá ser afixado em lugar de ampla visibilidade e se apresentar em tamanho e em grafia que viabilizem a
compreensão e visualização por parte do consumidor participante da promoção comercial;
            <br />
            <br />
            Além dos termos acima, a promoção comercial deverá obedecer às condições previstas na Lei nº 5.768, de 1971, no Decreto nº
70.951, de 1972, Portaria MF nº 41, de 2008, Portaria MF nº 67, de 2017, Portaria MF nº 422 de 2013, Portaria Seae/MF nº 88 de 2000, e em atos que as complementarem.
            <br />
            <br />
            Para as modalidades "Sorteio" e "Assemelhada a Sorteio" a empresa deverá anexar a Lista de Participantes na aba
"Apurações", contendo nomes e números da sorte distribuídos, após o término de cada período de participação e antes da
extração da Loteria. O arquivo deverá ser no formato .csv, .xls ou .zip e cada arquivo poderá ter até 250 MB.
            <br />
            <br />
            A infringência às cláusulas do Termo de Responsabilidade e do Regulamento constituem descumprimento do plano de operação
e ensejam as penalidade previstas no artigo 13 da Lei nº. 5.768, de 1971.
            <br />
          </Text>
        </ListItem>
        <br />
      </OrderedList>
    </>
  );
};

export default RulesText;
